module.exports = __webpack_public_path__ + "img/crv.ade177cc.svg";